import Vue from "vue";
import MutationTypes from "./mutation-types";
import _ from "lodash";

const mutations = {};

mutations[MutationTypes.SET_BREADCRUMBS_OPENED] = (state, payload) => {
	state.breadcrumbsOpened = payload;
	localStorage.setItem(
		"store.state.breadcrumbsOpened",
		JSON.stringify(state.breadcrumbsOpened)
	);
};

mutations[MutationTypes.SET_MQTT_CREDENTIALS] = (state, payload) => {
	state.credentials.mqtt = payload;
};

mutations[MutationTypes.SET_USERNAME] = (state, payload) => {
	if (_.isString(payload) === true) {
		state.user.username = payload.trim();
	}
};

mutations[MutationTypes.SET_PRIMARY_CLIENT] = (state, payload) => {
	if (_.isInteger(payload) === true) {
		state.user.primaryClientId = payload;
	}
};

mutations[MutationTypes.SET_ROLES] = (state, payload) => {
	if (_.isArray(payload) === true) {
		state.user.roles = payload;
	}
};

mutations[MutationTypes.SET_FEATURES] = (state, payload) => {
	if (_.isArray(payload) === true) {
		state.user.features = payload;
	}
};

mutations[MutationTypes.SET_LABELMAPPINGS] = (state, payload) => {
	if (_.isObject(payload) === true) {
		state.user.labelMappings = payload;
	}
};

mutations[MutationTypes.SET_PROFILE_ATTRIBUTES] = (state, payload) => {
	state.client.logoImageUrl = payload.logourl;
	state.user.profileAttributes = payload;
};

mutations[MutationTypes.MQTT_SUBSCRIBE] = (state, payload) => {
	Vue.set(state.mqtt.subscriptions, payload.name, payload.subscription);
};

mutations[MutationTypes.MQTT_UNSUBSCRIBE] = (state, subscriptionName) => {
	Vue.delete(state.mqtt.subscriptions, subscriptionName);
};

mutations[MutationTypes.ADD_TOAST] = (state, payload) => {
	state.toasts.push(payload);
};

mutations[MutationTypes.DISMISS_TOAST] = (state, toast) => {
	// Vue.delete(state.mqtt.subscriptions, subscriptionName);
	const id = state.toasts.indexOf(toast);
	if (!isNaN(id)) {
		state.toasts.splice(id, 1);
	}
};

mutations[MutationTypes.SET_MAP_ZOOM] = (state, payload) => {
	state.map.zoom = payload;
};

mutations[MutationTypes.SET_MAP_CENTER] = (state, payload) => {
	state.map.center = payload;
};

mutations[MutationTypes.SET_TILE_PROVIDER_VISIBILITY] = (state, name) => {
	const newtp = _.map(state.map.tileProviders, t => {
		return Object.assign(t, { visible: t.name === name });
	});
	Vue.set(state.map, "tileProviders", newtp);
};

export default mutations;
